<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Registrar Nuevo Tipo documento</v-toolbar>
        <v-card-text>
          <v-container class="mt-1">
            <v-text-field label="Descripcion" v-model.trim="documento.descripcion_SIN" dense outlined></v-text-field>
            <v-select
              label="Tipo documento"
              v-model="documento.codigo_clasificador_SIN"
              :items="tipos"
              item-value="codigo"
              dense
              outlined
            ></v-select>
          </v-container>
          <v-progress-linear indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="save()" color="green" class="darken-2">
            {{ documento.id ? 'Actualizar' : 'Registrar' }}
          </v-btn>
          <v-btn text @click="dialog.value = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        msg: '',
        tipos: [],
        documento: {
          id: null,
          codigo_clasificador_SIN: null,
          descripcion_SIN: '',
        },
      };
    },
    components: {},
    watch: {},
    methods: {
      openmodal(item) {
        this.msg = '';
        this.dialog = true;
        this.getdocumentos();
        this.documento.id = null;
        this.documento.descripcion_SIN = '';
        this.documento.codigo_clasificador_SIN = null;
        if (item) {
          this.documento.id = item.id;
          this.documento.descripcion_SIN = item.descripcion_SIN;
          this.documento.codigo_clasificador_SIN = item.codigo_clasificador_SIN;
        }
      },
      getdocumentos() {
        const vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/catalogo/tipodocumentoidentidad`,
          headers: {
            apikey: this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let datos = response.data;
            window.console.log(datos);
            if (datos.length > 0) {
              vue.tipos = [];
              datos.map((x) => {
                x.codigo = parseInt(x.codigo);
                x.text = `(${x.codigo}) ${x.descripcion}`;
              });
              vue.tipos = datos;
            }
          })
          .catch(function(error) {
            window.console.log(error);
          });
      },
      save() {
        this.msg = '';
        if (!this.documento.codigo_clasificador_SIN) this.msg = 'Seleccione un codigo clasificador.';
        if (!this.documento.descripcion_SIN) this.msg = 'Ingrese la descripcion SIN.';
        if (this.msg) return;

        let metodo = 'post';
        if (this.documento.id) metodo = 'put';
        this.loading = true;
        const vue = this;
        var config = {
          method: metodo,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/tiposdocumentos`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: this.documento,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('documentonew::', data);
            if (data.data) {
              vue.msg = data.data;
              vue.$emit('newregdocumento', vue.documento);
            }
            vue.loading = false;
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
    },
  };
</script>
